// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tag-image-container[data-v-9ea5c964] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #e0e0e0;\n}\n.tag-image[data-v-9ea5c964] {\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
